import { useContext } from "react"
import { Grid } from "@mui/material"
import UserContextP from "Interfaces/Context"

interface PropsInterface {
    order:any
    color:string
}

const InformationDocument = ( props: PropsInterface ) => {
    const { order } = props
    const context = useContext(UserContextP)
  
    return (
        <>
            <Grid className="item-cell" item xs={12}>
                <div className="thBase thHeader">
                    <p>
                        Información del documento
                    </p>
                </div>
            </Grid>
            
            <Grid className="item-cell" item xs={6} >
                <div className="thBase thContent">
                    <h4>Total Lineas</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6} style={{ textAlign: "right" }}>
                <div className=" thBase thContent item-details">
                    <h4>$ {context.separatorMiles(order?.totalLines)}</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6} >
                <div className="thBase thContent">
                    <h4>Descuento %</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6} style={{ textAlign: "right" }}>
                <div className=" thBase thContent item-details">
                    <h4>{order?.discount.toFixed(2)}%</h4>
                </div>
            </Grid>

            <Grid className="item-cell" item xs={6} >
                <div className="thBase thContent">
                    <h4>Descuento $</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6} style={{ textAlign: "right" }}>
                <div className=" thBase thContent item-details">
                    <h4>${context.separatorMiles(order?.totalLines * (order?.discount)/100)}</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6} >
                <div className="thBase thContent">
                    <h4>Subtotal</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6}  style={{ textAlign:"right"}}>
                <div className=" thBase thContent item-details">
                    <h4>$ {context.separatorMiles(order?.subtotal)}</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6}>
                <div className=" thBase thContent item-details">
                    <h4>IVA</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6} style={{ textAlign:"right"}}>
                <div className="thBase thContent item-details">
                    <h4>$ {context.separatorMiles(order?.subtotal * 0.13)}</h4>
                </div>
            </Grid>

            <Grid className="item-cell" item xs={6}>
                <div className=" thBase thContent item-details">
                    <h4>Retencion</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6} style={{ textAlign: "right" }}>
                <div className="thBase thContent item-details">
                    <h4>$ {context.separatorMiles((order?.retention ?? 0))}</h4>
                </div>
            </Grid>
            <Grid className="item-cell" item xs={6}>
                <div className="thBase thContent">
                    <h4>Total del documento</h4>
                </div>
            </Grid>

            <Grid className="item-cell" item xs={6} style={{ textAlign:"right"}}>
                <div className="thBase thContent item-details">
                    <h4>$ {context.separatorMiles(order?.total)}</h4>
                </div>
            </Grid>
        </>
    )
}

export default InformationDocument